var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { UitkText } from 'uitk-react-text';
import { UitkIcon } from 'uitk-react-icons';
import { UitkButtonSize, UitkTertiaryButton } from 'uitk-react-button';
import { UitkMenu, UitkMenuTrigger, UitkMenuContainer, PositionType } from 'uitk-react-menu';
import { UitkSpacing } from 'uitk-react-spacing';
import { getGCSectionData, toMenuItem } from '../gc-section-data';
var SHOP_TRAVEL = 'ShopTravel';
var ALL_TRAVEL = 'AllTravel';
var AdditionalHeaderMenus = /** @class */ (function (_super) {
    __extends(AdditionalHeaderMenus, _super);
    function AdditionalHeaderMenus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdditionalHeaderMenus.prototype.render = function () {
        var _a = this.props, analytics = _a.analytics, globalComponentsContext = _a.globalComponentsContext;
        var navLinks = globalComponentsContext && getGCSectionData(globalComponentsContext, 'header', 'navLinks');
        var menus = navLinks
            && navLinks.sectionData.filter(function (menu) { return menu.type === 'menu' && menu.id !== SHOP_TRAVEL && menu.id !== ALL_TRAVEL; });
        if (!menus) {
            return null;
        }
        var setupTracker = function (description) {
            var id = "Header.".concat(description);
            var callback = function (_id, _description) {
                if (analytics !== undefined) {
                    analytics.clickTracker(_id, _description, {}, function () { return null; }, true)();
                }
            };
            return {
                callback: callback,
                description: description,
                id: id
            };
        };
        return (React.createElement(React.Fragment, null, menus.map(function (menu) { return React.createElement(AdditionalMenu, { menu: menu, key: menu.id, analytics: analytics, setupTracker: setupTracker }); })));
    };
    return AdditionalHeaderMenus;
}(React.PureComponent));
export { AdditionalHeaderMenus };
export var AdditionalMenu = function (_a) {
    var menu = _a.menu, analytics = _a.analytics, setupTracker = _a.setupTracker;
    var _b = __read(React.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var menuItems = menu && menu.data && menu.data.map(function (link) { return ({
        analytics: setupTracker(link.trackingEvent),
        className: 'uitk-list-item',
        label: link.text,
        href: link.url,
        typeAnchor: true,
        attributes: {
            role: 'menuitem',
            tabindex: 0
        },
        icon: link.iconName,
        openInNewTab: link.newWindow,
        dataStid: link.dataStid
    }); });
    var menuTriggerAnalytics = analytics.setupTracker("Header.".concat(menu.id), "Expand ".concat(menu.id.toLowerCase(), " dropdown"));
    var icon = (menu === null || menu === void 0 ? void 0 : menu.iconName)
        && (React.createElement(UitkSpacing, { padding: { inlinestart: 'half', blockend: 'half' } },
            React.createElement(UitkIcon, { name: menu.iconName })));
    var text = (menu === null || menu === void 0 ? void 0 : menu.text) && React.createElement(UitkText, { size: 300, "data-stid": menu.dataStid }, menu.text);
    return (
    // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
    React.createElement(UitkMenu, { id: "gc-custom-header-tool-bar-".concat(menu.id, "-menu"), isOpen: isOpen, onTriggerClick: function () { return setIsOpen(!isOpen); } },
        React.createElement(UitkMenuTrigger, null, text ? (React.createElement(UitkTertiaryButton, { analytics: menuTriggerAnalytics }, menu.iconPosition === 'RIGHT' ? (React.createElement(React.Fragment, null,
            text,
            icon)) : (React.createElement(React.Fragment, null,
            icon,
            text)))) : (React.createElement(UitkTertiaryButton, { analytics: menuTriggerAnalytics, size: UitkButtonSize.LARGE }, icon))),
        React.createElement(UitkMenuContainer, { position: PositionType.LEFT },
            React.createElement("div", { className: "uitk-list" }, (menuItems || []).map(toMenuItem)))));
};
AdditionalMenu.displayName = 'AdditionalMenu';
//# sourceMappingURL=additional-header-menus.js.map